module.exports = __webpack_public_path__ + "img/2025-12-20c_1.88e6dbcf.jpg";